import React from 'react'
import { withRouter } from 'react-router-dom'
import { AuthContext } from '../../main/authProvider'
import HandleErrorService from '../../app/service/handleErrorService'
import GeneralServices from '../../app/service/generalServices'
import ConstantsUtil from '../../context/constantsUtil'
import DateIntervalCalendar from '../../components/calendar/dateIntervalCalendar'
import Card from '../../components/card'
import { Button } from 'primereact/button'
import AuthService from '../../app/service/authService'
import ImportacaoFolhaDePagamentoDialog from '../../components/contasAPagar/folhaDePagamento/importacaoFolhaDePagamentoDialog'
import FolhaDePagamentoService from '../../app/service/contasAPagar/folhaDePagamentoService'
import { Column } from 'primereact/column'
import SelectMenu from '../../components/selectMenu'
import FolhaDePagamentoTable from '../../components/contasAPagar/folhaDePagamento/folhaDePagamentoTable'
import { Dialog } from 'primereact/dialog'
import * as popUp from '../../components/toastr'


class FolhaDePagamento extends React.Component {

    constructor(){
        super()
        this.dtProventos = React.createRef()
        this.dtDescontos = React.createRef()
        this.dtLiquido = React.createRef()
        this.folhaDePagamentoService = new FolhaDePagamentoService()
    }    

    state = {

        selectedDateFilterType: '',
        missingFilterType: false,
        missingAnyDate: false,
        initialDate: '',
        initialDateView: '',
        finalDate: '',
        finalDateView: '',
        
        tipoProcessoFolhaDePagamento: '',
        inputTipoProcessoFolhaDePagamentoClass: '',
        
        displayImportacaoDialog: false,

        habilitaBusca: true,
        displayDeleteConfirmation: false,

        relatorio: null,
        relatorioProventos: null,
        relatorioDescontos: null,
        relatorioLiquido: null,

        isFinishedSearch: false,


    }

    hideImportacaoDialog = () => {
        this.setState({displayImportacaoDialog: false})
    }

    handleDateFilterChange = (selectedDateFilterType) => {
        this.setState({selectedDateFilterType})
    }

    handleDateChange = async (initialDate, finalDate) => {
        await this.handleInitialMonthDateChange(initialDate)
        await this.handleFinalMonthDateChange(finalDate)
    }

    handleInitialMonthDateChange = async (initialDate) => {
        await this.setState({initialDate})
        await this.setState({initialDateView: GeneralServices.convertBrStringToJsDate(initialDate)})
    }

    handleFinalMonthDateChange = async (finalDate) => {
        await this.setState({finalDate})
        await this.setState({finalDateView: GeneralServices.convertBrStringToJsDate(finalDate)})
    }

    handleChange = (event) => {
        const value = event.target.value
        const name = event.target.name
        this.setState( { [name]: value }, () => {
        })
    }    


    resetView = () => {
        this.setState({
            missingFilterType: false,
            missingAnyDate: false,
            inputTipoProcessoFolhaDePagamentoClass: '',
            isFinishedSearch: false,
        })
    }

    checkData = () => {

        var check = true

        if(!this.state.selectedDateFilterType){
            this.setState({missingFilterType: true})
            check=false
        }
        
        if(!this.state.initialDate || !this.state.finalDate){
            this.setState({missingAnyDate: true})
            check=false
        }

        if(!this.state.tipoProcessoFolhaDePagamento){
            this.setState({inputTipoProcessoFolhaDePagamentoClass: ConstantsUtil.bootstrapInputErrorClass})
            check=false            
        }

        return check
    }

    callSearch = () => {
        this.resetView()
        if(this.checkData()){
            this.search()
        }
    }


    toggleButton = async () => {
        await this.setState({habilitaBusca: !this.state.habilitaBusca})
    }    

    search = () => {
        
        AuthService.startBlockUi()

        this.toggleButton()

        this.folhaDePagamentoService.getRelatorio(this.state.initialDate, this.state.finalDate, this.state.tipoProcessoFolhaDePagamento)
        .then(async response => {
            // console.log("response: ", response.data)
            
            // response.data.proventos.forEach(item => item.nome = item.descricao)

            let relatorioProventos = JSON.parse(JSON.stringify(response.data))
            relatorioProventos.list = relatorioProventos.proventos
            this.trataLabels(relatorioProventos.list, response.data.descricaoMesesList)
            
            let relatorioDescontos = JSON.parse(JSON.stringify(response.data))
            relatorioDescontos.list = relatorioDescontos.descontos
            this.trataLabels(relatorioDescontos.list, response.data.descricaoMesesList)

            let relatorioLiquido = JSON.parse(JSON.stringify(response.data))
            relatorioLiquido.list = [relatorioLiquido.liquido]
            this.trataLabels(relatorioLiquido.list, response.data.descricaoMesesList)
            
            this.setState({
                relatorio: JSON.parse(JSON.stringify(response.data)),
                relatorioProventos,
                relatorioDescontos,
                relatorioLiquido,
                isFinishedSearch: true
            })
        })
        .catch(error => {
            console.log("error: ", error)
            this.toggleButton()
            HandleErrorService.handleError(error)
        })
        .finally(() => {
            AuthService.stopBlockUi()
        })
    }

    
    trataLabels(list, descricaoMesesList){
        
        // console.log("trataLabels: ", list)

        list.forEach(item => {

            item.nome = item.item.descricao
            item.realNome = item.nome
            item.showNome = item.nome

            item.codigo = item.item.codigo
            item.realCodigo = item.codigo
            item.showCodigo = item.codigo
            
            // console.log("item: ", item)
    
            item.total = item.valorTotal
            item.realTotal = item.total
            item.showTotal = item.total
    
            descricaoMesesList.forEach(descricaoMes => {
                // console.log("descricaoMes: ", descricaoMes)
                // console.log("item: ", item)
                let mesObj = item.relatorioMesMap[descricaoMes]
                mesObj.total = mesObj.valor
                if(mesObj && mesObj.total){
                    mesObj.showTotal = mesObj.total
                    mesObj.realTotal = mesObj.total
                }
                else{
                    mesObj = {total: ''}
                    item.relatorioMesMap[descricaoMes] = mesObj
                }
            })
        })

        list.forEach(item => {
            descricaoMesesList.forEach(descricaoMes => {
                item[descricaoMes] = item.relatorioMesMap[descricaoMes].total
            })
        })

        // console.log("list tratada: ", list)
    }
    
    resetTotalItem =  (list) => {
        // console.log("resetTotalItem: ", list)
        let totalItem = GeneralServices.findTotalItem(list)
        if(totalItem){
            // console.log("totalItem: ", totalItem)
            totalItem.nome = totalItem.realNome
            totalItem.showNome = totalItem.realNome

            totalItem.codigo = totalItem.realCodigo
            totalItem.showCodigo = totalItem.realCodigo

            totalItem.total = totalItem.realTotal
            totalItem.showTotal = totalItem.realTotal

            totalItem.porcentagem = totalItem.realPorcentagem
            totalItem.showPorcentagem = totalItem.realPorcentagem

            this.state.relatorio.descricaoMesesList.forEach(descricaoMes => {
                let totalItemMesObj = totalItem.relatorioMesMap[descricaoMes]
                if(totalItemMesObj){
                    totalItemMesObj.showTotal = totalItemMesObj.realTotal
                }
            })
            
        }
    }

    onFilterTable = (currentList, dt) => {

        if(currentList && currentList.length > 0){

            // console.log("currentList: ", currentList)

            //caso tenha lista após filtro, coloca os dados de um dos itens na linha de totais, para que ele também apareça no filtro
            const templateItem = currentList[0]
            // console.log("templateItem: ", templateItem)
            let totaisItem = GeneralServices.findTotalItem(dt.current.props.value)
            // console.log("totaisItem inicial: ", templateItem)
            //Iguala linha de totais a um dos itens resultantes do filtro, para que totais apareça também na lista filtrada.
            totaisItem.codigo =  templateItem.codigo
            totaisItem.nome =  templateItem.nome
            totaisItem.total =  templateItem.total
            // totaisItem.porcentagem =  templateItem.porcentagem
            this.state.relatorio.descricaoMesesList.forEach(descricaoMes => {
                const totalMesObj = totaisItem.relatorioMesMap[descricaoMes]
                const templateMesObj = templateItem.relatorioMesMap[descricaoMes]
                if(totalMesObj && templateMesObj){
                    if(!templateMesObj.showTotal){
                        templateMesObj.showTotal = ''
                    }
                    totaisItem[descricaoMes] = templateMesObj.showTotal
                    totalMesObj.total = templateMesObj.total
                }
            })
            // console.log("totaisItem: ", totaisItem)

            let totalObjFiltrado = this.calculaTotalFiltrado(currentList)
            // console.log("totalObjFiltrado: ", totalObjFiltrado)
            totaisItem.showTotal = totalObjFiltrado.valorTotalFiltrado
            // totaisItem.showPorcentagem = totalObjFiltrado.porcentagemTotalFiltrada

            this.state.relatorio.descricaoMesesList.forEach(descricaoMes => {
                const totalSomaMes = totalObjFiltrado.objTotalMeses[descricaoMes];
                let mesInTotalItem = totaisItem.relatorioMesMap[descricaoMes]
                if(!mesInTotalItem){
                    mesInTotalItem={}
                }
                mesInTotalItem.showTotal = totalSomaMes
                mesInTotalItem.total = totalSomaMes
            })

            // console.log("totaisItem: ", totaisItem)
            // console.log("currentList: ", currentList)

        }
    }

    calculaTotalFiltrado = list => {

        let valorTotalFiltrado = 0
        
        let objTotalMeses = {}
        this.state.relatorio.descricaoMesesList.forEach(descricaoMes => {
            objTotalMeses[descricaoMes] = 0
        })

        list.forEach(item => {
            if(item.showNome !== ConstantsUtil.tipoTotaisFichaBancariaLabel){
                valorTotalFiltrado+=item.total

                this.state.relatorio.descricaoMesesList.forEach(descricaoMes => {
                    let itemMesObj = item.relatorioMesMap[descricaoMes]
                    if(itemMesObj && itemMesObj.total){
                        let currentValorInObjTotalMeses = objTotalMeses[descricaoMes]
                        objTotalMeses[descricaoMes] = currentValorInObjTotalMeses+=itemMesObj.total
                    }
                })
            }
        })
        valorTotalFiltrado = GeneralServices.formatTo2CasasDecimais(valorTotalFiltrado)
        this.state.relatorio.descricaoMesesList.forEach(descricaoMes => {
            objTotalMeses[descricaoMes] = GeneralServices.formatTo2CasasDecimais(objTotalMeses[descricaoMes])
        })
        const returnObj = {valorTotalFiltrado, objTotalMeses}
        // console.log("returnObj: ", returnObj)
        return returnObj
    }

    getMappedItemToExport = (item, descricaoMesesList) => {
        
        let exportItem = {}
        
        exportItem['Código'] = item.item.codigo
        exportItem['Descrição'] = item.item.descricao
        exportItem['Tipo'] = item.item.proventoOuDesconto

        descricaoMesesList.forEach(descricaoMes => {
            exportItem[descricaoMes] = item[descricaoMes]
        })

        exportItem['Total'] = item.total

        return exportItem

    }

    getListToExport = (list) => {

        let exportList = list.map(item => {
            return this.getMappedItemToExport(item, this.state.relatorio.descricaoMesesList)
        })

        exportList.push({})
        
        return exportList
    }

    getFilenameToExport = () => {
        // console.log("this.state.relatorio.descricaoMesesList: ", this.state.relatorio.descricaoMesesList)
        let mesInicial = this.state.relatorio.descricaoMesesList[0]
        let mesFinal = this.state.relatorio.descricaoMesesList.at(-1)
        let nomeEmrpesa = AuthService.getEmpresa()
        let tipoProcesso = this.state.tipoProcessoFolhaDePagamento

        console.log("mesInicial: ", mesInicial)
        console.log("mesFinal: ", mesFinal)
        console.log("nomeEmrpesa: ", nomeEmrpesa)
        console.log("tipoProcesso: ", tipoProcesso)

        return `Folha de Pagamento - ${nomeEmrpesa} - Resumo ${tipoProcesso} - ${mesInicial} a ${mesFinal}`
    }

    exportExcel = () => {
        // console.log("this.state.relatorioProventos:", this.state.relatorioProventos)
        // console.log("this.state.relatorioDescontos:", this.state.relatorioDescontos)
        // console.log("this.state.relatorioLiquido:", this.state.relatorioLiquido)
        let exportList = []
        exportList.push(...this.getListToExport(this.state.relatorioProventos.list))
        exportList.push(...this.getListToExport(this.state.relatorioDescontos.list))
        exportList.push(...this.getListToExport(this.state.relatorioLiquido.list))
        
        GeneralServices.exportExcel(exportList, "Resumo", this.getFilenameToExport())
    }

    delete = () => {

        const body = {
            mes: this.state.initialDate,
            tipoProcesso: this.state.tipoProcessoFolhaDePagamento
        }

        AuthService.startBlockUi()
        this.folhaDePagamentoService.deleteFolhaDePagamento(body)
        .then(async response => {
            popUp.successPopUp("Folha de Pagamento removido com sucesso!")
          
            this.hideDeleteDialog()
            this.toggleButton()
        }).catch(async error => {
            this.hideDeleteDialog()
            HandleErrorService.handleError(error)
        })
        .finally(() => {
            AuthService.stopBlockUi()
        })
    }

    inativarFolhaDePagamento = () => {
    this.setState({
        displayDeleteConfirmation: true
    })
    }

    habilitarExclusao = () => {

        const isPersonalizado = this.state.selectedDateFilterType === ConstantsUtil.calendarPersonalizadoFilterLabel
        const isDataIguais = this.state.initialDate === this.state.finalDate && this.state.initialDate  !== '' && this.state.finalDate  !== ''
        const isProcessoDiferente = this.state.tipoProcessoFolhaDePagamento?.trim() !== "GERAL" && this.state.tipoProcessoFolhaDePagamento?.trim() !== ""
        const habilitarDelete = isPersonalizado && isDataIguais && isProcessoDiferente
        return habilitarDelete

    }

    hideDeleteDialog = () => {
        this.setState({displayDeleteConfirmation: false})
    }

    render(){

        const renderDeleteConfirmationFooter = () => {
                return (
                    <div>
                        <Button label="Confirmar" icon="pi pi-check"
                            onClick={this.delete} 
                            autoFocus
                        />
                        <Button label="Cancelar" icon="pi pi-times" onClick={this.hideDeleteDialog}
                                className="p-button-text" />
                    </div>
            );
        }

        const renderImportarButton = () => {
            return (
                <Button 
                    label="Importar Resumo da Folha de Pagamento"
                    className="p-button-success"
                    icon="pi pi-upload"
                    onClick = {() => this.setState({displayImportacaoDialog: true})}
                    disabled={!this.state.habilitaBusca}
                />
            )
        }

        const renderImportacaoDialog = () => {
            return (
                <ImportacaoFolhaDePagamentoDialog
                    visible={this.state.displayImportacaoDialog}
                    hideDialog={this.hideImportacaoDialog}
                />
            )
        }

        const renderDialog = () => {

            return (       
                <Dialog
                    header="Excluir Folha de Pagamento"
                    modal = {true}
                    visible={this.state.displayDeleteConfirmation}
                    style={{ width: '350px' }}
                    footer={renderDeleteConfirmationFooter()}
                    onHide={this.hideDeleteDialog}
                >
                    <div className="confirmation-content row" style={{marginLeft: '10px'}}>
                        <i className="pi pi-exclamation-triangle p-mr-3" style={{ fontSize: '2rem', marginRight: '10px'}} />
                    <div style={{marginBottom: '10px'}}> Deseja confirmar? </div>
                    </div>
                </Dialog>
            )
        }

        const renderCalendarFilters = () => {
            return (
                <>
                <div className = "col-md-12">
                    
                    <div className="row">

                        <DateIntervalCalendar
                            htmlFor="SelectDatePeriod"
                            label="Escolher período"
                            ano
                            defaultValue={ConstantsUtil.calendarAnoCompletoFilterLabel}
                            handleFilterChange={this.handleDateFilterChange}
                            handleDateChange={this.handleDateChange}
                            handleInitialMonthDateChange={this.handleInitialMonthDateChange}
                            handleFinalMonthDateChange={this.handleFinalMonthDateChange}
                            missingFilterType={this.state.missingFilterType}
                            missingAnyDate={this.state.missingAnyDate}
                            disabled={!this.state.habilitaBusca}
                        />

                        <div className = "col-md-2">
                            <label>Tipo de Processo</label>
                            <SelectMenu
                                className={"form-control " + this.state.inputTipoProcessoFolhaDePagamentoClass}
                                name="tipoProcessoFolhaDePagamento"
                                list={ConstantsUtil.tipoProcessoFolhaSelectList} 
                                value={this.state.tipoProcessoFolhaDePagamento}
                                onChange={this.handleChange}
                                disabled={!this.state.habilitaBusca}
                            />
                            <div className="invalid-feedback">Informe o Tipo de Processo</div>                              
                        </div>

                    </div>
                </div>
                </>
            )
        }

        const renderExcluirButton = () => {
            if(this.habilitarExclusao()){
                return (
                    <Button
                        label="Excluir"
                        className="p-button-danger small-button"
                        icon="pi pi-trash"
                        onClick={this.inativarFolhaDePagamento}
                        tooltip="Excluir folha de Pagamento"
                        style ={{marginLeft: '10px'}}
                        tooltipOptions={{position: 'top'}}
                    />
                )
            }
        }

        const renderButtons = () => {
            if(this.state.habilitaBusca){
                return (
                    <div>
                        <Button
                            label="Gerar Relatório"
                            className='small-button'
                            icon="pi pi-search"
                            onClick = {this.callSearch}
                            // style={ {maxHeight: '35px' } }
                            disabled = {!this.state.habilitaBusca}
                        />
                    </div>
                )
            }
            return (
                <div
                    style={{marginBottom: '0.8rem' } }
                >
                    <Button
                        label="Voltar"
                        className="p-button-danger small-button"
                        icon="pi pi-undo"
                        onClick = {this.toggleButton}
                    />
                    <Button
                        label="Exportar"
                        className="p-button-success small-button"
                        icon="pi pi-file-excel"
                        onClick={this.exportExcel}
                        tooltip={ConstantsUtil.exportXlsxLabel}
                        style ={{marginLeft: '10px'}}
                        tooltipOptions={{position: 'top'}}
                    />
                    {renderExcluirButton()}
                </div>
            )
        }        

        const renderTable = (dt, stateRelatorio, tipo) => {
            if(!this.state.habilitaBusca && this.state.isFinishedSearch){
                return (
                    <div className='borda'>
                        <FolhaDePagamentoTable
                            dt={dt}
                            relatorio={stateRelatorio}
                            tipo={tipo}
                            qtdMeses={this.state.relatorio?.descricaoMesesList?.length}
                            resetTotalItem={this.resetTotalItem}
                            onFilterTable={this.onFilterTable}
                        />
                    </div>
                )
            }
        }        

        return(
            <div className="bs-docs-section " >
                <Card
                    title = "Folha De Pagamento"
                    rightComponent={renderImportarButton()}
                >

                    {renderImportacaoDialog()}

                    <div className = "col-md-12">
                        <div className="row">
                            {renderCalendarFilters()}
                        </div>

                        <div
                            style={{marginTop: '0.5rem', marginBottom: '0.5rem'}}
                        >
                            {renderButtons()}
                            {renderDialog()}

                            <div className="visaorj-small">
                                {renderTable(this.dtProventos, this.state.relatorioProventos, ConstantsUtil.proventoFolha)}
                                
                                <br/>
                                
                                {renderTable(this.dtDescontos, this.state.relatorioDescontos, ConstantsUtil.descontoFolha)}
                                
                                <br/>
                                
                                {renderTable(this.dtLiquido, this.state.relatorioLiquido, ConstantsUtil.liquidoFolha)}
                            </div>
                        </div>
                    
                    </div>

                </Card>
                <div className="d-flex "/>
            </div>             
        )
    }


}

FolhaDePagamento.contextType = AuthContext

export default withRouter(FolhaDePagamento)